import { useTranslation, Trans } from "react-i18next";
import BoxesFroSmall from "./BoxesFroSmall";
import listIcon from "../img/list.svg";
import styles from "../css/heatmaps/ResultsHM.module.css";
import backgroundImg from "../img/results_bg.svg";
import Pack from "./Pack";



const ResultsHM = () => {
  const { t } = useTranslation();
  const content = t("heatmaps.results", { returnObjects: true });

  return (
    <Pack dataComponent={"results-heatmaps"} sectionInlineStyle={{paddingTop: 0}}>
      <div className={styles.container}>
        <img className={styles.background} src={backgroundImg} alt="" />
        <div className={styles.contentBox}>
          <div className={styles.headingSection}>
            <h2>{content.heading}</h2>
          </div>
          <div className={styles.textSection}>
            <div className={styles.texts}>
              {content.texts &&
                content.texts.map((text, index) => (
                  <p
                    key={index}
                    className={
                      styles[`textItem${index + 1}`] || styles.textItem
                    }
                  >
                    {<Trans i18nKey={text} components={[<strong></strong>]} />}
                  </p>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.containerSmall}>
        <BoxesFroSmall content={content} icons={[listIcon]}>
          <h2>{content.heading}</h2>
        </BoxesFroSmall>
      </div>
    </Pack>
  );
};

export default ResultsHM;
